export default __webpack_public_path__ + "static/shisham-150x150-a46fe07eda3c9793efcdc85eb709de8b.png";